import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { environment } from '@coin/shared/core/util-environments';
import { UpdateNotificationsService } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'admin-app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderComponent {
  protected updateNotifications = inject(UpdateNotificationsService);

  get currentEnvironment(): typeof environment {
    return environment;
  }
}
